import React from 'react';
import styled from 'styled-components';
import { StateButton, StateButtonProps } from '~common/components/button/state-button.component';
import { ArrowRightIcon } from '~web/view/components/ui/icon/arrow-right.icon';

export const ArrowRightButton: React.FunctionComponent<StateButtonProps> = ({ ...rest }) => (
  <StyledStateButton {...rest}>
    <StyledArrowRightIcon width={12} height={18} />
  </StyledStateButton>
);

const StyledStateButton = styled(StateButton)`
  && {
    min-width: 54px;
    width: 54px;
    height: 54px;
    padding: 0;
  }
`;

const StyledArrowRightIcon = styled(ArrowRightIcon)`
  margin-left: 2px;
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/button/arrow-right-button.component.tsx